import Schema from 'validate';
import { isPostalCode } from 'validator';
import isEmail from 'validator/lib/isEmail';
import OrganisationSchema from '../../../../../lib/paths/unternehmen_FULL_Paths.json';
let P = OrganisationSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const OrganisationDataValidator = new Schema({
	[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Adresszusatz.path]: {
		type: String,
	},
	[P.Adressdaten_PLZ.path]: {
		type: String,
		required: true,
		use: {
			postalCode: (val: string) => isPostalCode(val, 'DE'),
		},
		message: {
			postalCode: 'Diese Postleitzahl ist ungültig.',
		},
	},
	[P.Adressdaten_Ort.path]: {
		type: String,
		required: true,
	},
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Fax.path]: {
		type: String,
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
	[P.Kontaktdaten_Webadresse.path]: {
		type: String,
	},
	[P.Geschaeftsbezogene_Daten_Kurzbeschreibung_Der_Organisation.path]: {
		type: String,
	},
	[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
		type: String,
	},
});

OrganisationDataValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichtfeld.',
	type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
});

export default OrganisationDataValidator;
